module.exports = __webpack_public_path__ + "a4dbfc6ed4c8a4e448fd63fa27de44aa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/blanket-orange.png
// module id = 1852
// module chunks = 0